import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
  name: "searchThemes",
})
export class SearchThemesPipe implements PipeTransform {
  transform(pipeData, pipeModifier): any {
    if (pipeModifier != "THEME") {
      return pipeData.filter((eachItem) => {
        if (eachItem["fields"]["theme"]) {
          return eachItem["fields"]["theme"].includes(pipeModifier)
        }
      })
    } else {
      return pipeData
    }
  }
}
